import React, { useState, useRef } from "react";
import "../Style/ClientProjects.css";
import PageFooter from "../components/Footer";

const projects = [
  {
    id: 1,
    title: "Mr. Arunkumar Balusamy",
    description:
      "A personal profile website showcasing Mr. Arun Kumar Balusamy’s leadership journey, business legacy, KKB brand success, social contributions, and achievements.",
    images: ["/assets/clientsimg/ak.png"],
    appLink: "",
    websiteLink: "https://arunkumarkkb.com/",
    socialLink: "",
  },
  {
    id: 2,
    title: "KKB Lungies and Textiles",
    description:
      "A textile and apparel showcase website featuring premium lungies, traditional wear collections, and high-quality textile manufacturing services.",
    images: ["/assets/clientsimg/kkb.png"],
    appLink: "",
    websiteLink: "https://www.kkbstore.com/",
    socialLink: "",
  },
  {
    id: 3,
    title: "Sri Kurumba Bhagavathy Temple",
    description:
      "A dedicated temple website showcasing the heritage, festivals, gallery, and spiritual activities of Sri Kurumba Bhagavathy Temple, Puthussery Palakkad.",
    images: ["/assets/clientsimg/temple.png"],
    appLink: "",
    websiteLink: "https://pudusserysreekurumbatemple.in/",
    socialLink: "",
  },
  {
    id: 4,
    title: "Dr. Murugan's Wellness Centre",
    description:
      "A professional wellness website showcasing doctor guided nutrition, movement, preventive care, and sustainable lifestyle solutions for healthier living.",
    images: ["/assets/clientsimg/murugan.png"],
    appLink: "",
    websiteLink: "https://drmuruganswellnesscentre.in/",
    socialLink: "",
  },
  {
    id: 5,
    title: "CKV Brahmins Catering",
    description:
      "A professional catering website showcasing authentic Brahmin vegetarian cuisine, traditional flavors, and generations of culinary expertise for memorable celebrations and special occasions.",
    images: ["/assets/clientsimg/ckv.png"],
    appLink: "",
    websiteLink: "https://ckvbrahminscatering.com/",
    socialLink: "",
  },
  {
    id: 6,
    title: "R.Manikandan",
    description:
      "A personal portfolio website showcasing Raman Manikandan’s work as a Director, Screenwriter & Actor, featuring his films, creative projects, professional journey, and achievements.",
    images: ["/assets/clientsimg/director.png"],
    appLink: "",
    websiteLink: "https://directormanikandan.com/",
    socialLink: "",
  },
  {
    id: 7,
    title: "AA&ID",
    description:
      "An architecture and interior design showcase website featuring contemporary spaces, thoughtfully crafted interiors, and innovative design solutions.",
    images: ["/assets/clientsimg/aaid.png"],
    appLink: "",
    websiteLink: "https://aa-id-51b1e.web.app/",
    socialLink: "",
  },
  {
    id: 8,
    title: "Darsana Events",
    description:
      "A luxury event venue website showcasing elegant wedding spaces, premium hospitality, and seamless event experiences in Palakkad.",
    images: ["/assets/clientsimg/darsana.png"],
    appLink: "",
    websiteLink: "https://darsanaeventspace.in/",
    socialLink: "",
  },
  {
    id: 9,
    title: "New waves bridal studio",
    description:
      "A stylish bridal studio website showcasing bridal makeup, hairstyling, beauty services, packages, and stunning bridal looks.",
    images: ["/assets/clientsimg/wave.png"],
    appLink: "",
    websiteLink: "https://newwavesbridalstudio.com/",
    socialLink: "",
  },
  {
    id: 10,
    title: "Sree Gopalakrishna Electricals",
    description:
      "A professional electrical website showcasing quality electrical products, industrial solutions, and reliable services for commercial and industrial needs.",
    images: ["/assets/clientsimg/sgk.png"],
    appLink: "",
    websiteLink: "https://sreegopalakrishnaelectricals.in/",
    socialLink: "",
  },
  {
    id: 11,
    title: "Flow Dynamics",
    description:
      "A professional industrial website showcasing engineering solutions, high-performance components, and reliable maintenance services for process and manufacturing industries.",
    images: ["/assets/clientsimg/flow.png"],
    appLink: "",
    websiteLink: "https://flowdynamics.in/",
    socialLink: "",
  },
  {
    id: 12,
    title: "Golden Wedding Company",
    description:
      "A professional wedding events website showcasing elegant wedding decorations, curated collections, event planning services, and memorable celebrations tailored to every couple’s special day.",
    images: ["/assets/clientsimg/golden.png"],
    appLink: "",
    websiteLink: "https://golden-wedding-event.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 13,
    title: "Kalpaka Catering and events",
    description:
      "A professional catering and events website showcasing delicious culinary experiences, customized catering services, and seamless event management for weddings, celebrations, and special occasions.",
    images: ["/assets/clientsimg/kalpaka.png"],
    appLink: "",
    websiteLink: "https://kalpakacatering.com/",
    socialLink: "",
  },
  {
    id: 14,
    title: "Anappuram Furniture",
    description:
      "A professional furniture website showcasing premium wooden furniture, elegant designs, and quality craftsmanship for stylish and comfortable living spaces.",
    images: ["/assets/clientsimg/anappuramfurniture.png"],
    appLink: "",
    websiteLink: "https://anappuramfurniture.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 15,
    title: "Firm Fit",
    description:
      "A professional fitness website showcasing personalized workout programs, expert trainers, membership plans, and fitness solutions designed to build strength and support a healthier lifestyle.",
    images: ["/assets/clientsimg/firmfit.png"],
    appLink: "",
    websiteLink: "https://firmfit.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 16,
    title: "V-Star",
    description:
      "A professional logistics website showcasing reliable cargo transportation, freight management, warehousing, and delivery solutions designed to support efficient and seamless business operations.",
    images: ["/assets/clientsimg/vstarcargoservices.png"],
    appLink: "",
    websiteLink: "https://vstarcargoservices.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 17,
    title: "Lavanya Trends",
    description:
      "An online saree store where customers can browse a wide range of traditional and modern sarees, explore collections, and shop their favorite styles with a seamless online shopping experience.",
    images: ["/assets/clientsimg/lavanya.png"],
    appLink: "",
    websiteLink: "https://lavanyatrends-d5c7b.web.app/",
    socialLink: "",
  },
  {
    id: 18,
    title: "Lokal",
    description:
      "A local service booking platform that connects customers with trusted home service providers for easy appointment booking, allowing users to schedule, manage, and track their service requests online.",
    images: ["/assets/clientsimg/lokal.png"],
    appLink: "",
    websiteLink: "https://lokal-userpanel.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 19,
    title: "Edgetech Skills",
    description:
      "Build your skills with practical training and industry-relevant certifications designed to prepare you for today’s growing career opportunities.",
    images: ["/assets/clientsimg/edge.png"],
    appLink: "",
    websiteLink: "https://www.edgetechskills.com/",
    socialLink: "",
  },
  {
    id: 20,
    title: "NithiX",
    description:
      "A smart business management platform that simplifies billing, invoicing, and inventory tracking, helping businesses manage sales, monitor stock levels, and streamline daily operations efficiently.",
    images: ["/assets/clientsimg/nithix.png"],
    appLink: "",
    websiteLink: "https://nithi-billing.netlify.app/#login",
    socialLink: "",
  },
  {
    id: 21,
    title: "Lent Finance",
    description:
      "Providing reliable, transparent, and flexible financial solutions with quick approvals to support your personal and business needs.",
    images: ["/assets/clientsimg/lent.png"],
    appLink: "",
    websiteLink: "https://lentfinance.com/",
    socialLink: "",
  },
  {
    id: 22,
    title: "KingandQueen Unisex Salon",
    description:
      "A modern salon website showcasing beauty services, styling expertise, appointment booking, and premium grooming experiences for men and women.",
    images: ["/assets/clientsimg/kk.png"],
    appLink: "",
    websiteLink: "https://kingandqueenunisexsalon.com/",
    socialLink: "",
  },
  {
    id: 23,
    title: "Power Best",
    description:
      "Reliable electrical solutions with trusted expertise, quality execution, and industry-focused service.",
    images: ["/assets/clientsimg/power.png"],
    appLink: "",
    websiteLink: "https://powerbest.in/",
    socialLink: "",
  },
  {
    id: 24,
    title: "AMBADY KANNAN",
    description:
      "Safe, reliable, and efficient freight transportation across Kerala and Tamil Nadu.",
    images: ["/assets/clientsimg/kannan.png"],
    appLink: "",
    websiteLink: "https://ambadykannantransport.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 25,
    title: "SALKARA INN",
    description:
      "A premium stay offering comfort, elegance, and warm hospitality for every guest.",
    images: ["/assets/clientsimg/salkaara.png"],
    appLink: "",
    websiteLink: "https://salkarainn.in/",
    socialLink: "",
  },
  {
    id: 26,
    title: "Greentech Industries",
    description:
      "An industrial business website highlighting innovative manufacturing solutions, quality products, and sustainable engineering services for diverse industries.",
    images: ["/assets/clientsimg/gt1.png"],
    appLink: "",
    websiteLink: "https://greentechindustries.in/",
    socialLink: "",
  },
  {
    id: 27,
    title: "Arklon® Lap Spools",
    description:
      "An industrial website highlighting Emmark Industries’ precision-engineered Arklon® lap spools, advanced manufacturing capabilities, and excellence in textile solutions.",
    images: ["/assets/clientsimg/arklon.png"],
    appLink: "",
    websiteLink: "https://arklonlapspool.com/",
    socialLink: "",
  },
  {
    id: 28,
    title: "Dr. Capt.P.E.J. Rajan",
    description:
      "A personal brand portfolio website highlighting Dr. Capt. P.E.J. Rajan’s maritime experience, accomplishments, services, and contributions",
    images: ["/assets/clientsimg/rajan.png"],
    appLink: "",
    websiteLink: "https://kingmarine.web.app/",
    socialLink: "",
  },
  {
    id: 29,
    title: "Pragya HR",
    description:
      "A professional HR consultancy platform offering recruitment solutions, workforce management, talent acquisition, and staffing services for businesses.",
    images: ["/assets/clientsimg/pr1.png"],
    appLink: "",
    websiteLink: "https://pragyahr.in/",
    socialLink: "",
  },
  {
    id: 30,
    title: "TERRA PALM",
    description:
      "A sustainable craft and lifestyle website showcasing handcrafted products made from natural, locally sourced materials, transforming agricultural waste into beautiful and eco-conscious creations.",
    images: ["/assets/clientsimg/terra.png"],
    appLink: "",
    websiteLink: "https://terra-palm.mpeoplesnet.com/",
    socialLink: "",
  },
  {
    id: 31,
    title: "Saranya R",
    description:
      "Portfolio of Saranya R., an award-winning director and storyteller with 8+ years of experience and 100+ episodes across visual storytelling",
    images: ["/assets/clientsimg/Saranya.png"],
    appLink: "",
    websiteLink: "https://director-saranya.web.app/",
    socialLink: "",
  },
  {
    id: 32,
    title: "Makkal Sinthanai Peravai",
    description:
      "A cross-platform shopping app with product catalog, cart, and payment integration.",
    images: [
      "/assets/makkal/1.png",
      "/assets/makkal/2.png",
      "/assets/makkal/3.png",
      "/assets/makkal/4.png",
    ],
    appLink:
      "https://play.google.com/store/apps/details?id=com.sinthanai.peravai",
    websiteLink: "",
    socialLink: "",
  },
  {
    id: 33,
    title: "Dr. Dhanraj MCA, M.Phil, Ph.D",
    description:
      "Dedicated educator and researcher committed to enhancing students' performance through innovative teaching methodologies and cutting-edge computer science applications.",
    images: ["/assets/clientsimg/dn.png"],
    appLink: "",
    websiteLink: "https://drdhanraj.vercel.app/",
    socialLink: "",
  },
  {
    id: 34,
    title: "MPON Gold",
    description:
      "Discover the purity and elegance of our fine gold collections. Whether you're looking for investment opportunities or timeless jewelry, we provide trusted and certified gold for every purpose.",
    images: ["/assets/clientsimg/mpon.png"],
    appLink: "",
    websiteLink: "https://mpon-gold.vercel.app/",
    socialLink: "",
  },
  {
    id: 35,
    title: "Green Play Turf",
    description:
      "Where Passion Meets the Perfect Turf “Play Hard. Play Smart. Play Here.”",
    images: ["/assets/clientsimg/turf.png"],
    appLink: "",
    websiteLink: "https://turf-nu.vercel.app/",
    socialLink: "",
  },
  {
    id: 36,
    title: "Fit Believe",
    description:
      "Push your limits, break barriers, and transform yourself every single day. Our expert trainers and state-of-the-art equipment are here to guide your journey.",
    images: ["/assets/clientsimg/gym.png"],
    appLink: "",
    websiteLink: "https://gym-ten-mu.vercel.app/",
    socialLink: "",
  },
  {
    id: 37,
    title: "RM Rishi Gold",
    description:
      "Since 1985, we've been providing the finest quality gold jewelry with complete transparency and customer satisfaction.",
    images: ["/assets/clientsimg/rmgold.png"],
    appLink: "",
    websiteLink: "https://rm-rishi-gold.vercel.app/",
    socialLink: "",
  },
  {
    id: 38,
    title: "Makkal Sinthani Peravai",
    description:
      "மக்கள் சிந்தனைப் பேரவை (Makkal Sinthanai Peravai) என்பது தமிழகத்தில், குறிப்பாக ஈரோட்டில் செயல்படும் ஒரு சமூக அமைப்பு.",
    images: ["/assets/mspweb/1.png"],
    appLink: "",
    websiteLink: "https://www.makkalsinthanaiperavai.com/",
    socialLink: "",
  },
  {
    id: 39,
    title: "Erode Book Festival",
    description:
      "The Book fair organized in the South Indian city of Erode, Tamil Nadu. It is organised by a social organisation named Makkal Sindhanai Peravai.",
    images: ["/assets/ebfweb/1.png"],
    appLink: "",
    websiteLink: "https://www.erodebookfestival.in/",
    socialLink: "",
  },
  {
    id: 40,
    title: "T Stalin Gunasekaran",
    description:
      "தமிழக பேச்சாளார், எழுத்தாளர்; ஈரோடு மக்கள் சிந்தனைப் பேரவையின் தலைவர்",
    images: ["/assets/tsgweb/1.png"],
    appLink: "",
    websiteLink: "https://tstalingunasekaran.in/",
    socialLink: "",
  },
  {
    id: 41,
    title: "Fresh Fruits",
    description:
      "We’re more than just a fruit store—we’re a brand committed to promoting wellness",
    images: ["/assets/clientsimg/fruit.png"],
    appLink: "",
    websiteLink: "https://fresh-fruits-seven-sigma.vercel.app/",
    socialLink: "",
  },
  {
    id: 42,
    title: "Interiors",
    description:
      "Transform Your Space Into Art, Premium interior design services tailored to your vision",
    images: ["/assets/clientsimg/int.png"],
    appLink: "",
    websiteLink: "https://interiors-xi.vercel.app/",
    socialLink: "",
  },
  {
    id: 43,
    title: "Nakshatra Catering",
    description: "Premium Wedding Catering & Events",
    images: ["/assets/clientsimg/nakshathra.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/nakshatra_catering_events/",
  },
  {
    id: 44,
    title: "Thulasi Events",
    description: "Turning your visions into unforgettable celebrations",
    images: ["/assets/clientsimg/thulasi.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/thulasieventspkd/?hl=en",
  },
  {
    id: 45,
    title: "Reboot",
    description: "Counselling Psychologist",
    images: ["/assets/clientsimg/reboot.png"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/reboot.now_?stkn=d3Y3M2k2bHN1aml4&utm_source=qr",
  },
  {
    id: 46,
    title: "Adhiyamaan College of Engineering",
    description: "Achieve Create Excel",
    images: ["/assets/clientsimg/adhi.webp"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/adhiyamaancollegeofengineering/?hl=en",
  },
  {
    id: 47,
    title: "Tariga",
    description: "Relax, Refresh, Renew - The Herbal Way",
    images: ["/assets/clientsimg/tar.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/tharigaherbalsanitarynapkins/",
  },
  {
    id: 48,
    title: "KR Power",
    description: "Strength that supports every structure",
    images: ["/assets/clientsimg/kr.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/krcabletray/",
  },
  {
    id: 49,
    title: "Fly Birds",
    description: "From Sunrise to Sunset",
    images: ["/assets/clientsimg/fly.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/flybirds.official/",
  },
  {
    id: 50,
    title: "ORCHID BUILDERS",
    description: "Engineering your dreams",
    images: ["/assets/clientsimg/orch.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/orchid_builders_",
  },
  {
    id: 51,
    title: "CIMAT-MBA College",
    description: "Coimbatore Institute of Management and Technology",
    images: ["/assets/clientsimg/cimat.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/cimat.cbe/",
  },
  {
    id: 52,
    title: "SOA - Architect College",
    description: "School of Architecture",
    images: ["/assets/clientsimg/soa.jpeg"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/soaciet_official/",
  },
  {
    id: 53,
    title: "CIET- Engineering College",
    description: "Coimbatore Institute of Engineering and Technology",
    images: ["/assets/clientsimg/ciet.png"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/cietinfo/?hl=en",
  },
  {
    id: 54,
    title: "KKCAS - Arts and science college",
    description: "Light the light within",
    images: ["/assets/clientsimg/kkcas.png"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/kovai_kalaimagal_cbe?utm_source=ig_web_button_share_sheet&psln=ZDNlZDc0MzIxNw%3D%3D",
  },
  {
    id: 55,
    title: "King and Queen salon",
    description: "Salon and studio",
    images: ["/assets/clientsimg/king.png"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/king_queen_pkd/",
  },
  {
    id: 56,
    title: "Greentech Industries",
    description: "Kerala agro industries empanelling company",
    images: ["/assets/clientsimg/greentech.png"],
    appLink: "",
    websiteLink: "",
    socialLink: "https://www.instagram.com/green_tech.industries?srtk=Nzhib2wybDMzdnJh",
  },
];

const mpbs__filters = [
    { key: "all", label: "All Projects" },
    { key: "website", label: "Websites" },
    { key: "app", label: "Apps" },
    { key: "social", label: "Social Media" },
];

const ClientProjects = () => {
    const [mpbs__activeFilter, setMpbs__activeFilter] = useState("all");
    const mpbs__gridRef = useRef(null);

    const mpbs__filtered = projects.filter((p) => {
        if (mpbs__activeFilter === "all") return true;
        if (mpbs__activeFilter === "website") return !!p.websiteLink;
        if (mpbs__activeFilter === "app") return !!p.appLink;
        if (mpbs__activeFilter === "social") return !!p.socialLink;
        return true;
    });

    const mpbs__counts = {
        all: projects.length,
        website: projects.filter((p) => p.websiteLink).length,
        app: projects.filter((p) => p.appLink).length,
        social: projects.filter((p) => p.socialLink).length,
    };

    const mpbs__handleFilter = (key) => {
        setMpbs__activeFilter(key);
        setTimeout(() => {
            mpbs__gridRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 50);
    };

    return (
        <section className="mpbs__clp-section">

            {/* ── HEADER ── */}
            <div className="mpbs__clp-header">
                <div className="mpbs__clp-header-deco mpbs__clp-header-deco--a" />
                <div className="mpbs__clp-header-deco mpbs__clp-header-deco--b" />
                <div className="mpbs__clp-header-deco mpbs__clp-header-deco--c" />

                <div className="mpbs__clp-header-inner">
                    <div className="mpbs__clp-header-left">
                        <span className="mpbs__clp-eyebrow">Our Work</span>
                        <h2 className="mpbs__clp-heading">
                            Client <span className="mpbs__clp-heading-accent">Projects</span>
                        </h2>
                        <p className="mpbs__clp-subtitle">
                            A curated showcase of websites, mobile apps, and brand identities
                            delivered across industries — built with precision and purpose.
                        </p>
                    </div>

                    <div className="mpbs__clp-stat-wrap">
                        <div className="mpbs__clp-stat-badge">
                            <span className="mpbs__clp-stat-number">{projects.length}+</span>
                            <span className="mpbs__clp-stat-label">Projects Delivered</span>
                        </div>
                        <div className="mpbs__clp-stat-divider" />
                        <div className="mpbs__clp-stat-badge">
                            <span className="mpbs__clp-stat-number">
                                {mpbs__counts.website}
                            </span>
                            <span className="mpbs__clp-stat-label">Websites</span>
                        </div>
                        <div className="mpbs__clp-stat-divider" />
                        <div className="mpbs__clp-stat-badge">
                            <span className="mpbs__clp-stat-number">{mpbs__counts.app}</span>
                            <span className="mpbs__clp-stat-label">Apps</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── BODY ── */}
            <div className="mpbs__clp-body">

                {/* ── FILTERS ── */}
                <div className="mpbs__clp-filter-bar">
                    <div className="mpbs__clp-filter-pills">
                        {mpbs__filters.map(({ key, label }) => (
                            <button
                                key={key}
                                onClick={() => mpbs__handleFilter(key)}
                                className={
                                    "mpbs__clp-pill" +
                                    (mpbs__activeFilter === key ? " mpbs__clp-pill--active" : "")
                                }
                                aria-pressed={mpbs__activeFilter === key}
                            >
                                <span className="mpbs__clp-pill-label">{label}</span>
                                <span className="mpbs__clp-pill-count">
                                    {mpbs__counts[key]}
                                </span>
                            </button>
                        ))}
                    </div>
                    <p className="mpbs__clp-result-count">
                        Showing <strong>{mpbs__filtered.length}</strong> project
                        {mpbs__filtered.length !== 1 ? "s" : ""}
                    </p>
                </div>

                {/* ── GRID ── */}
                <div className="mpbs__clp-grid" ref={mpbs__gridRef}>
                    {mpbs__filtered.map((project, i) => (
                        <article
                            className="mpbs__clp-card"
                            key={project.id}
                            style={{ animationDelay: `${(i % 12) * 45}ms` }}
                        >
                            {/* top accent bar */}
                            <div className="mpbs__clp-card-topbar" />

                            {/* image zone */}
                            <div
                                className={
                                    "mpbs__clp-card-imgzone" +
                                    (project.images.length > 1
                                        ? " mpbs__clp-card-imgzone--multi"
                                        : "")
                                }
                            >
                                {project.images.slice(0, 4).map((img, idx) => (
                                    <img
                                        key={idx}
                                        src={img}
                                        alt={`${project.title} screenshot ${idx + 1}`}
                                        className="mpbs__clp-card-img"
                                        loading="lazy"
                                    />
                                ))}
                            </div>

                            {/* card body */}
                            <div className="mpbs__clp-card-body">
                                {/* <span className="mpbs__clp-card-tag">{project.tag}</span> */}
                                <h3 className="mpbs__clp-card-title">{project.title}</h3>
                                <p className="mpbs__clp-card-desc">{project.description}</p>

                                <div className="mpbs__clp-card-actions">
                                    {project.websiteLink && (
                                        <a
                                            href={project.websiteLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="mpbs__clp-btn mpbs__clp-btn--primary"
                                        >
                                            Visit Website
                                            <svg className="mpbs__clp-btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 13L13 3M13 3H7M13 3V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </a>
                                    )}
                                    {project.appLink && (
                                        <a
                                            href={project.appLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="mpbs__clp-btn mpbs__clp-btn--primary"
                                        >
                                            View App
                                            <svg className="mpbs__clp-btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 13L13 3M13 3H7M13 3V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </a>
                                    )}
                                    {project.socialLink && (
                                        <a
                                            href={project.socialLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="mpbs__clp-btn mpbs__clp-btn--ghost"
                                        >
                                            Social Media
                                            <svg className="mpbs__clp-btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 13L13 3M13 3H7M13 3V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}

                    {mpbs__filtered.length === 0 && (
                        <div className="mpbs__clp-empty">
                            <div className="mpbs__clp-empty-icon">
                                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" />
                                    <path d="M16 24h16M24 16v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>
                            <p className="mpbs__clp-empty-text">No projects in this category yet.</p>
                        </div>
                    )}
                </div>
            </div>
            <PageFooter />
        </section>
    );
};

export default ClientProjects;